// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3v3KD","row":"ProcedureTreatmentSummary_row__2olf5"};